// Security
export const SecurityLevels = {
  RESTRICTED: 1,
  USER: 2,
  POWER: 3,
  ADMIN: 4,
  SUPPORT: 4,
};

class Security {
  constructor() {
    this.SecurityLevels = SecurityLevels;
    this.currentSecurityLevel = SecurityLevels.RESTRICTED;

    this.config = {
      dashboard: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.POWER,
      },
      filters: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.POWER,
      },
      kpis: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.POWER,
      },
      view: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.RESTRICTED,
      },
      monitor: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.POWER,
      },
      integration: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.ADMIN,
      },
      settings: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.RESTRICTED,
      },
      switchAccount: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.RESTRICTED,
      },
      eventConfig: {
        read: SecurityLevels.POWER,
        write: SecurityLevels.POWER,
      },
      actions: {
        read: SecurityLevels.POWER,
        write: SecurityLevels.POWER,
      },
      connect: {
        read: SecurityLevels.ADMIN,
        write: SecurityLevels.ADMIN,
      },
      delete: {
        read: SecurityLevels.ADMIN,
        write: SecurityLevels.ADMIN,
      },
      tokens: {
        read: SecurityLevels.POWER,
        write: SecurityLevels.POWER,
      },
      docs: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.RESTRICTED,
      },
      user: {
        read: SecurityLevels.RESTRICTED,
        write: SecurityLevels.RESTRICTED,
      },
      manageUsers: {
        read: SecurityLevels.ADMIN,
        write: SecurityLevels.ADMIN,
      },
      branding: {
        read: SecurityLevels.ADMIN,
        write: SecurityLevels.ADMIN,
      },
    };
  }

  setCurrentUser({ level }) {
    if (!(level in SecurityLevels)) {
      throw new Error(`unknown level ${level}`);
    }
    this.currentSecurityLevel = SecurityLevels[level];
  }

  clearCurrentUser() {
    this.currentSecurityLevel = SecurityLevels.RESTRICTED;
  }

  canRead(key) {
    return this.config[key].read <= this.currentSecurityLevel;
  }

  canWrite(key) {
    return this.config[key].write <= this.currentSecurityLevel;
  }
}

export default new Security();
